import { categoryBySlugSerializer } from '~/domains/category';
import { type ActionByIdResponse, type ActionById } from '../types';
import promotionSeializer from './promotion.serializer';

export default function promotionByIdSerializer(
  data: ActionByIdResponse,
): ActionById {
  return {
    action: promotionSeializer(data.action),
    catalog: categoryBySlugSerializer(data.catalog),
  };
}
